module.exports = __webpack_public_path__ + "img/index-pic5.fd50b80b.webp";